<template>
  <div v-if="!readOnly || (readOnly && equipments.length > 0)">
    <div class="row box-container mt-4 ml-1">
      <div class="col-12">
        <label v-if="readOnly">{{ inputLabel }}</label>
        <CustomInput
          v-if="!readOnly"
          v-model="itemToAdd"
          :label="inputLabel"
          :placeholder="inputPlaceholder"
          :prepend-icon-left="false"
          error-class=""
          :left-icon="false"
          :prepend-icon="prependIcon"
          :prepend-icon-type="prependIconType"
          :btn-transparent="true"
          :prepend-icon-color="prependIconColor"
          :btn-border-color="btnBorderColor"
          :prepend-icon-click="addEquipment"
        />
        <div class="row">
          <div class="col-12 ml-3">
            <CustomChipsGroup
              :selected-items="equipments"
              title="Equipos Seleccionados"
              :no-background="true"
              :no-wrap="true"
              object-text="name"
              :on-item-deleted="removeEquipment"
              :disabled="readOnly"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomInput from 'CustomInput';
import CustomChipsGroup from 'CustomChipsGroup';

export default {
  name: 'EquipmentAdd',
  components: {
    CustomInput,
    CustomChipsGroup,
  },
  props: {
    tableId: {
      type: String,
      default: () => null,
    },
    inputLabel: {
      type: String,
      default: () => null,
    },
    inputPlaceholder: {
      type: String,
      default: () => null,
    },
    prependIcon: {
      type: String,
      default: () => null,
    },
    prependIconType: {
      type: String,
      default: () => null,
    },
    prependIconColor: {
      type: String,
      default: () => null,
    },
    btnBorderColor: {
      type: String,
      default: () => null,
    },
    visible: {
      type: Boolean,
      default: () => false,
    },
    readOnly: {
      type: Boolean,
      default: () => false,
    },
    addedEquipment: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    addEquipment() {
      this.itemToAdd = this.itemToAdd?.trim();
      if (this.itemToAdd) {
        this.equipments.push({ id: ++this.itemIdCount, name: this.itemToAdd });
        this.$emit('addEquipment', this.itemToAdd, this.tableId);
        this.itemToAdd = '';
      }
    },
    removeEquipment(item) {
      let equipmentIndex = this.equipments.findIndex((e) => e.id === item.id);
      this.equipments.splice(equipmentIndex, 1);
      this.$emit('removeEquipment', equipmentIndex, this.tableId);
    },
    clear() {
      this.equipments = [];
    },
  },
  data() {
    return {
      itemToAdd: null,
      itemIdCount: 0,
      equipments: [],
    };
  },
  mounted() {
    this.equipments = this.addedEquipment;
  },
};
</script>
<style scoped>
::v-deep .chips-container p {
  color: #11291b !important;
}

.box-container {
  background-color: #f7f7f7;
  padding: 15px;
  border-radius: 5px;
}

.box-container >>> .data-label {
  color: black !important;
}
</style>
